import { AbregelungKopplungsTyp } from '../../../domain/model/abregelung-kopplungs-typ.enum';

export class RowDescriptor {
    description: string;
    required: boolean;

    constructor(description: string, b: boolean) {
        this.description = description;
        this.required = b;
    }

    // return a human friendly name for the Kopplungstyp
    public static getNameForType(type: AbregelungKopplungsTyp): RowDescriptor {
        if (type === AbregelungKopplungsTyp.SOLLWERT) {
            return new RowDescriptor('SOLLWERT', true);
        }
        if (type === AbregelungKopplungsTyp.TYP_100) {
            return new RowDescriptor('100', true);
        }
        if (type === AbregelungKopplungsTyp.TYP_60) {
            return new RowDescriptor('60', true);
        }
        if (type === AbregelungKopplungsTyp.TYP_30) {
            return new RowDescriptor('30', true);
        }
        if (type === AbregelungKopplungsTyp.TYP_0) {
            return new RowDescriptor('0', true);
        }
        if (type === AbregelungKopplungsTyp.BLINDLEISTUNG_Q) {
            return new RowDescriptor('BLINDLEISTUNG Q', false);
        }
        if (type === AbregelungKopplungsTyp.WIRKLEISTUNG_P) {
            return new RowDescriptor('WIRKLEISTUNG P', false);
        }
        return new RowDescriptor('n/a', false);

    }
}
